export class ProducerValidate {
    constructor(
        public producerId: any,
        public producerNPN: any,
        public zipCode: any
    ) {

    }
}